module.exports = __webpack_public_path__ + "img/img-vm-code.f82796e7.png";